import { ArcButton } from "@src/core/ui";
import React from "react";
import { Sections } from "./components/Sections";
import { useNavigate } from "react-router-dom";
import ZoneDetailsPopup from '@src/features/zones/components/zone-details-popup';
import { selectSelectedZone } from '@src/features/zones/redux';
import { useSelector } from "react-redux";
import { useGetZonesQuery, ZoneType } from "@src/core/features";

export const ZonesPage: React.FC = () => {

  const { data: zones } = useGetZonesQuery();
             
  const getSortedZones = (type: ZoneType) =>
    zones
      ?.filter((z) => z.zoneType === type)
      .sort((a, b) => {
      // Активные всегда выше неактивных
        if (a.isActive && !b.isActive) return -1;
        if (!a.isActive && b.isActive) return 1;

        // Если оба активные → новые первыми
        if (a.isActive && b.isActive) {
          return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
        }

        // Если оба неактивные → старые первыми
        if (!a.isActive && !b.isActive) {
          return new Date(a.updatedAt).getTime() - new Date(b.updatedAt).getTime();
        }

        return 0;
      });


  const temporaryZones = getSortedZones(ZoneType.TEMPORARY);
  const permanentZones = getSortedZones(ZoneType.PERMANENT);

  const navigate = useNavigate(); 
  const selectedZone = useSelector(selectSelectedZone);
    
    
  return (            
    <React.Fragment>
      <ArcButton.brand  onClick={() => navigate('create')} sx={{ px: 2, py: 1 }}>
        Create Zone
      </ArcButton.brand>
      <Sections temporaryZones={temporaryZones} permanentZones={permanentZones}  />
      <ZoneDetailsPopup zone={selectedZone} />
    </React.Fragment>
  );
};